import { useMemo } from 'react';
import { Spinner } from '@ds';
import { getLogisticsLogs } from '@lp/features/RoutePlanner/utils';
import { useCaseDetailsWithReviews } from '@lp/features/RoutePlanner/hooks/useCaseDetailsWithReviews';
import { useCaseLogsQuery } from '@/queries/case';
import { TimelineItem } from './TimeLine';

export const LogisticsStatusLog = () => {
  const { caseId } = useCaseDetailsWithReviews();
  const { data, isLoading } = useCaseLogsQuery(caseId);

  const logs = useMemo(() => {
    if (!data?.length) return [];

    return getLogisticsLogs(data);
  }, [data]);

  return (
    <div className="flex justify-center rounded-md">
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="relative flex flex-col items-start">
          {logs.map((log, index) => (
            <TimelineItem
              key={`${log.eventType}-${log.createdAt}`}
              isPositive={log.isPositive}
              eventType={log.eventType}
              caseLog={log.logRecord}
              user={log.user}
              isLast={index === logs.length - 1}
              isFirst={!index}
              createdAt={log.createdAt}
            />
          ))}
        </div>
      )}
    </div>
  );
};
